export default __webpack_public_path__ + "static/media/document-multiplayer-icon.c10f4b85.svg";